import { ar } from './ar';
import { en } from './en';
import { es } from './es';
import { de } from './de';
import { zh } from './zh';
import { ja } from './ja';
import { he } from './he';

export const translations = {
  ar,
  en,
  es,
  de,
  zh,
  ja,
  he,
};

// RTL languages
export const rtlLanguages = ['ar', 'he'];

// Get direction based on language
export const getDirection = (lang) => {
  return rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
};

// Language display names
export const languageNames = {
  ar: 'العربية',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  zh: '中文',
  ja: '日本語',
  he: 'עברית',
};

// Language flags (emoji)
export const languageFlags = {
  ar: '🇸🇦',
  en: '🇺🇸',
  es: '🇪🇸',
  de: '🇩🇪',
  zh: '🇨🇳',
  ja: '🇯🇵',
  he: '🇮🇱',
};

export default translations;
